<template>
  <div>
    <!-- Fondo oscuro -->
    <div v-show="isVisible" class="overlay"></div>

    <!-- Card -->
    <md-card v-show="isVisible" class="custom-card">
      <div class="button-container">
        <md-button class="md-icon-button close-btn" @click="closeModal">
          X
        </md-button>
      </div>
      <md-card-content style="text-align: center; padding: 0">
        <img
          src="@/assets/img/MSI2025.png"
          alt="Promoción Meses Sin Intereses"
          class="img-fluid"
          style="max-width: 100%; height: auto; border-radius: 4px"
        />
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
export default {
  name: "PromotionsCard",
  data() {
    return {
      isVisible: false,
      bancos: [
        {
          nombre: "CitiBanamex",
          meses: [
            { plan: 3, recargo: "5.42%" },
            { plan: 6, recargo: "5.94%" },
            { plan: 12, recargo: "9.88%" },
          ],
        },
        {
          nombre: "BBVA",
          meses: [
            { plan: 3, recargo: "5.57%" },
            { plan: 6, recargo: "9.49%" },
            { plan: 12, recargo: "16.70%" },
          ],
        },
        {
          nombre: "AMEX",
          meses: [
            { plan: 3, recargo: "4.50%" },
            { plan: 6, recargo: "7.25%" },
            { plan: 12, recargo: "12.00%" },
          ],
        },
        {
          nombre: "BANREGIO",
          meses: [
            { plan: 3, recargo: "3.50%" },
            { plan: 6, recargo: "5.50%" },
            { plan: 12, recargo: "11.50%" },
          ],
        },
      ],
    };
  },
  methods: {
    openModal() {
      this.isVisible = true; // Mostrar el modal
    },
    closeModal() {
      this.isVisible = false; // Ocultar el modal
    },
  },
};
</script>

<style scoped>
/* Fondo oscuro */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1000;
}
/* Clase para texto negro y tamaño 10px */
.text-black-small {
  color: black;
  font-size: 10px;
  text-align: left;
  line-height: 1.5;
}

.highlight-text {
  color: #000000; /* Azul oscuro */
  font-weight: bold; /* Negrita */
}
.footnote {
  text-align: right;
  font-size: 8px;
  line-height: 1.5;
  color: black;
}
.footnote-end {
  text-align: center;
  font-size: 8px;
  line-height: 1.5;
  color: black;
}
/* Tarjeta centrada */
.custom-card {
  max-width: 400px;
  margin: 20px auto;
  padding: 16px;
  padding-bottom: 32px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1010;
  background-color: white;

  /* Ajuste de la altura */
  max-height: 500px; /* Reduce el largo máximo */
  overflow-y: auto; /* Habilita el desplazamiento */
}
/* Estilos del contenido */
.modal-title {
  text-align: center;
  font-weight: bold;
  color: #003366;
  font-size: 12px;
}

.button-container {
  text-align: right;
}

.md-icon-button.close-btn {
  font-size: 20px;
  color: black;
  background: none;
  border: none;
  cursor: pointer;
}

/* Tabla principal */

.promo-table {
  width: 100%;
  margin: 1rem 0;
  border-collapse: collapse;
  text-align: center;
  font-size: 10px;
  border: 1px solid #ddd; /* Bordes de la tabla */
}

/* Encabezado */
.promo-table th {
  background-color: #004080; /* Azul oscuro */
  color: white;
  font-size: 12px;
  font-weight: bold;
  padding: 2px;
  text-align: center;
  border: 1px solid #ddd;
}

/* Filas alternadas */
.promo-table tr:nth-child(odd) {
  background-color: #d4f1c5;
}

.promo-table tr:nth-child(even) {
  background-color: #c5e0f1;
}

/* Estilo de celdas */
.promo-table td {
  border: 1px solid #ddd;
  padding: 0px;
  text-align: center;
}

/* Estilos para tablas internas */
.inner-table {
  width: 100%;
  border-collapse: collapse; /* Elimina espacios entre bordes */
  background: none; /* Transparente para que herede el color de la fila */
}

.inner-table td {
  border: none; /* Elimina los bordes adicionales */
  padding: 0x;
  text-align: center;
  background: none; /* Transparente para que herede el color de la fila */
}

/* Asegurar consistencia en el color de fondo */
.promo-table tr:nth-child(odd) .inner-table td {
  background-color: #d4f1c5; /* Verde claro */
}

.promo-table tr:nth-child(even) .inner-table td {
  background-color: #c5e0f1; /* Azul claro */
}
</style>